import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

interface IEnableDisableDepartments {
  export_mileage_only: boolean;
  departments_enabled: boolean;
}

const enableDisableDepartments = (postData: IEnableDisableDepartments) => {
  const newEndpoints = endpoints.integrations.RUNByADP.enableDisableDepartment;
  return http().post(newEndpoints, postData);
};

export function useEnableDisableDepartments() {
  return useMutation({ mutationFn: enableDisableDepartments });
}
